export default function(e0, e1, e2, e3, phi) {
  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/mlfn.js
// module id = 39
// module chunks = 0 1